// PRODUCTION SERVICE
export const BaseURL = "https://api.contrate.ba.gov.br/";

// HOMOLOGATION SERVICE
// export const BaseURL = `http://10.18.0.3:8080/`;

// DEVELOPMENT SERVICE
// export const BaseURL = `http://10.18.246.37:8080/`;

// LOCAL SERVICE
// export const BaseURL = `http://localhost:8080/`;